import { ApiError } from '@schooly/api';
import { FieldValues, Path, UseFormReturn } from 'react-hook-form-lts';

type ApiErrorWithDetails = ApiError & { details?: string };

function getStringErrorDetails(error: ApiError): string | undefined {
  const details = (error as ApiErrorWithDetails).details;
  return typeof details === 'string' ? details : undefined;
}

export type SetFormErrorOptions<T extends FieldValues> = {
  field: Path<T>;
  errorToTranslationKey: Record<string, string>;
};

export function setFormErrorForApiError<T extends FieldValues>(
  error: ApiError,
  form: UseFormReturn<T>,
  options: SetFormErrorOptions<T>,
  getMessage: (translationKey: string) => string,
): void {
  const details = getStringErrorDetails(error);
  const translationKey = details ? options.errorToTranslationKey[details] : undefined;
  if (translationKey) {
    form.setError(options.field, {
      type: 'validate',
      message: getMessage(translationKey),
    });
    form.setFocus(options.field);
  }
}

export function isErrorByDetails(error: ApiError, keys: readonly string[]): boolean {
  const details = getStringErrorDetails(error);
  return details != null && keys.includes(details);
}
